import React from "react";
import PropTypes from "prop-types";
import { Button, Col, DatePicker, Form, Input, Row, Select } from "antd";
import { countryList } from "../../../../data/countryList";

const { Option } = Select;
const BasicFormFilter = ({ onSearch, onReset, courses, form }) => {
  const countryListMenu = countryList.map((country) => (
    <Option value={country.id}>{country.name}</Option>
  ));

  const enrolmentStatusMenu = [
    "Basic info only",
    "Payment details only",
    "Enrolled",
    "Completed all payment",
  ].map((status) => <Option value={status}>{status}</Option>);

  return (
    <Form form={form} onFinish={onSearch}>
      <Row gutter={16}>
        <Col span={4}>
          <Form.Item name="param" rules={[{ required: false }]}>
            <Select placeholder="Search by...">
              <Option value="name">First/Last Name</Option>
              <Option value="email">Email</Option>
              <Option value="courseOfferCode">Course Offer Code</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="val" rules={[{ required: false }]}>
            <Input placeholder="Enter the search term..." />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Course" name="courseCode">
            {courses ? (
              <Select
                options={courses}
                placeholder={"Select Courses"}
                mode={""}
                notFoundContent={null}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            ) : null}
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Country"
            name="countryId"
            rules={[{ required: false, message: "Please select Country!" }]}
          >
            <Select placeholder="Select a country">{countryListMenu}</Select>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col>
          <Form.Item label="Enrolment Status" name="enrolmentStatus">
            <Select placeholder={"Select Status"}>{enrolmentStatusMenu}</Select>
          </Form.Item>
        </Col>
        <Col>
          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[{ required: false, message: "Please input start date!" }]}
          >
            <DatePicker
              showTime={false}
              showNow={false}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>

        <Col>
          <Form.Item
            label="End Date"
            name="endDate"
            rules={[{ required: false, message: "Please input end date!" }]}
          >
            <DatePicker
              showTime={false}
              showNow={false}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Search
          </Button>
          <Button htmlType="button" onClick={onReset}>
            Reset
          </Button>
        </Form.Item>
      </Row>
    </Form>
  );
};

BasicFormFilter.propTypes = {
  onSearch: PropTypes.func,
  onReset: PropTypes.func,
  courses: PropTypes.array.isRequired,
};

export default BasicFormFilter;
